import React from "react";
import { Images } from "../../../Assets/0a-exporter";
import { GoogleLogin } from "react-google-login";
import "./google-login.style.scss";

const clientId =
  "928067010815-fuilcugmd571fe221l9bsteg3nm5erro.apps.googleusercontent.com";
export default function GoogleLoginCustom() {
  const onSuccess = (res) => {
  };
  const onFailure = (res) => {
    console.error("response", res);
  };
  return (
    <GoogleLogin
      clientId={clientId}
      buttonText=""
      onSuccess={onSuccess}
      onFailure={onFailure}
      cookiePolicy={"single_host_origin"}
      disabled={false}
      //   isSignedIn={true}
    >
      {/* <img src={Images.google}/> */}
    </GoogleLogin>
  );
}
